import React, { useState } from 'react';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';

interface Props {
    ecode: string;
    onLogin: (
        ecode: string,
        password: string
    ) => void;
    onBack: () => void;
    isLoading: boolean;
    error: string;
}

const PasswordStep: React.FC<Props> = ({ ecode, onLogin, onBack, isLoading, error }) => {
    const [password, setPassword] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!password.trim()) return;

        onLogin(ecode, password);
    };

    return (
        <div className="w-full max-w-sm border rounded-lg p-6 shadow-sm bg-card">
            <div className="mb-6 text-center">
                <h1 className="text-lg font-semibold">Management Information System</h1>
                <p className="text-sm text-muted-foreground">Sign in with TransIT</p>
            </div>

            {error && (
                <div className="mb-4 text-sm text-red-600">{error}</div>
            )}

            <form
                onSubmit={handleSubmit}
                className="space-y-4"
            >
                <div className="space-y-2">
                    <label className="text-sm font-medium">Employee Code</label>

                    <Input
                        value={ecode}
                        readOnly
                    />
                </div>

                <div className="space-y-2">
                    <label className="text-sm font-medium">Password</label>

                    <Input
                        type="password"
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                        placeholder="Enter password"
                        autoComplete="current-password"
                        disabled={isLoading}
                    />
                </div>

                <Button
                    type="submit"
                    className="w-full"
                    disabled={!password || isLoading}
                >
                    {isLoading ? 'Signing in...' : 'Login with TransIT'}
                </Button>

                <Button
                    type="button"
                    variant="outline"
                    className="w-full"
                    onClick={onBack}
                >
                    Back
                </Button>
            </form>
        </div>
    );
};

export default PasswordStep;